/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LexplusProfilbildDto } from '../../models/lexplus-profilbild-dto';

export interface AdminBenutzerverwaltungControllerUploadProfilbildV1$Params {
  id: string;
  
    /**
     * The image to store as the profile picture.
     */
    body: {
'file': Blob;
}
}

export function adminBenutzerverwaltungControllerUploadProfilbildV1(http: HttpClient, rootUrl: string, params: AdminBenutzerverwaltungControllerUploadProfilbildV1$Params, context?: HttpContext): Observable<StrictHttpResponse<LexplusProfilbildDto>> {
  const rb = new RequestBuilder(rootUrl, adminBenutzerverwaltungControllerUploadProfilbildV1.PATH, 'post');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LexplusProfilbildDto>;
    })
  );
}

adminBenutzerverwaltungControllerUploadProfilbildV1.PATH = '/v1/benutzerverwaltung/{id}/profilbild';
